import { httpApi } from "./http.api";

// payload
export interface ReportPayload {
    name: string;
    job: number;
    // template_id: number;
    search_log_id?: number;
    candidate_ids: number[];
}

export interface AddCandidatesToReportPayload {
    job: number;
    candidate_ids: number[];
}

// API to create a candidate report
export const createCandidateReport = (reportData: ReportPayload) => {
    return httpApi
        .post("report/report/", reportData)
        .then((res) => res.data);
};

export const addCandidatesToReport = (
    reportId: number,
    data: AddCandidatesToReportPayload
) => {
    return httpApi
        .put(`report/report/${reportId}/`, data)
        .then((res) => res.data);
};
